const COMPONENT_NAME = "Accordion";
export {
  COMPONENT_NAME
};
